import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvResubmitPage from './IdvResubmitPage';

const IdvResubmitRoute: FuseRouteItemType = {
  path: '',
  element: <IdvResubmitPage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvResubmitRoute;
